import { render, staticRenderFns } from "./UsuarioIndex.vue?vue&type=template&id=868357b0&scoped=true&"
import script from "./UsuarioIndex.vue?vue&type=script&lang=js&"
export * from "./UsuarioIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868357b0",
  null
  
)

export default component.exports